import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createNotificationAction, loadingToggleAction } from "../../../store/actions/notification/NotificationActions";

// Validation schema
const notificationSchema = Yup.object().shape({
  header: Yup.string().required("Please enter an title").max(65, "Maximum 65 characters allowed"),
  message: Yup.string().required("Please enter an message").max(250, "Maximum 250 characters allowed"),
  notification_type: Yup.string().required("Please select notification type"),
  in_app: Yup.boolean(),
});

const CreateNotification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialState = {
    header: "",
    message: "",
    in_app: false,
    notification_type: "",
  };
  const { loading, error, message } = useSelector((state) => state.notification);

  const handleSubmit = (values, { setSubmitting }) => {
    let payload = {
      ...values,
      user_ids: [],
      // notification_type: "all", // all, specific
    };
    dispatch(createNotificationAction(payload, navigate));
    setSubmitting(false);
  };

  const cancelHandler = () => {
    navigate("/notification");
  };

  return (
    <>
      <div className='page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item'>
            <Link to={"/notification"}>Notifications</Link>
          </li>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Create Notification</Link>
          </li>
        </ol>
      </div>

      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='form-validation'>
                <div className='needs-validation'>
                  <Formik initialValues={initialState} validationSchema={notificationSchema} onSubmit={handleSubmit}>
                    {({ setFieldValue, values, isSubmitting }) => (
                      <Form>
                        <div className='mb-4'>
                          <label className='col-form-label'>
                            Title
                            <span className='text-danger'>*</span>
                          </label>

                          <Field type='text' name='header' maxLength={65} className='form-control' placeholder='Enter Title' />
                          <ErrorMessage name='header' component='div' className='text-danger' />
                        </div>
                        <div className='mb-4'>
                          <label className='col-form-label'>
                            Notification type
                            <span className='text-danger'>*</span>
                          </label>

                          <Field as='select' name='notification_type' className='form-control'>
                            <option value=''>Select Notification Type</option>
                            <option value='Offers'>Offers</option>
                            <option value='App Update'>App Update</option>
                            <option value='Major Price Alert'>Major Price Alert</option>
                            <option value='Others'>Others</option>
                          </Field>
                          <ErrorMessage name='notification_type' component='div' className='text-danger' />
                        </div>

                        <div className='mb-4'>
                          <label className='col-form-label'>
                            Message
                            <span className='text-danger'>*</span>
                          </label>
                          <Field as='textarea' className='form-control' maxLength={250} name='message' style={{ height: "100px" }}></Field>
                          <ErrorMessage name='message' component='div' className='text-danger' />
                        </div>

                        <div className='mb-4 d-flex align-items-center'>
                          <label className='me-4 col-form-label'>In App Notification</label>
                          <div className='form-check form-switch'>
                            <Field type='checkbox' name='in_app' className='form-check-input' role='switch' id='in_app' onChange={() => setFieldValue("in_app", !values.in_app)} checked={values.in_app} />
                            <label className='form-check-label' htmlFor='in_app'></label>
                          </div>
                        </div>

                        <div className='mb-3 text-center'>
                          <div className='col-lg-9 mx-auto'>
                            <button type='submit' className='btn btn-danger me-3' onClick={cancelHandler}>
                              Cancel
                            </button>
                            <button type='submit' className='btn btn-primary' disabled={isSubmitting}>
                              Submit
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateNotification;
